import React from "react";
import Carousel from "react-multi-carousel";

import "./externalStyles.scss";

const emptyObj = {};

const getReponsiveBreakPoints = ({ superLarge = 5, desktop = 3, tablet = 2, mobile = 1 } = {}) => {
  return {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      slidesToSlide: superLarge,
      items: superLarge,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      slidesToSlide: desktop,
      items: desktop,
    },
    tablet: {
      breakpoint: { max: 1023, min: 768 },
      slidesToSlide: tablet,
      items: tablet,
    },
    mobile: {
      breakpoint: { max: 767, min: 0 },
      slidesToSlide: mobile,
      items: mobile,
      partialVisibilityGutter: 15,
    },
  };
};

const MultiCarousel = ({
  children,
  containerClass = "container-with-dots w-100",
  infinite = true,
  resolutionCountsMapping = emptyObj,
  showDots = false,
  slidesToSlide = 1,
  partialVisible = false,
  autoPlay = false,
  arrows = true,
  transitionDuration = 300,
  customTransition = "transform 300ms ease-in-out",
  autoPlaySpeed = 3000,
  itemClass = null,
  draggable = true,
  pauseOnHover = true,
  swipeable = true,
  centerMode = false,
  responsive = null,
  renderDotsOutside = false,
  dotListClass = null,
  className = null,
  customDot = null,
  afterChange = null,
}) => (
  <Carousel
    additionalTransfrom={0}
    arrows={arrows}
    autoPlaySpeed={autoPlaySpeed}
    centerMode={centerMode}
    className={className}
    containerClass={containerClass}
    dotListClass={dotListClass}
    draggable={draggable}
    focusOnSelect={false}
    infinite={infinite}
    itemClass={itemClass}
    keyBoardControl
    minimumTouchDrag={80}
    pauseOnHover={pauseOnHover}
    renderArrowsWhenDisabled={false}
    renderButtonGroupOutside={false}
    renderDotsOutside={renderDotsOutside}
    responsive={responsive || getReponsiveBreakPoints(resolutionCountsMapping)}
    rewind={false}
    rewindWithAnimation={false}
    rtl={false}
    shouldResetAutoplay
    showDots={showDots}
    sliderClass=""
    slidesToSlide={slidesToSlide}
    swipeable={swipeable}
    partialVisible={partialVisible}
    autoPlay={autoPlay}
    transitionDuration={transitionDuration}
    customTransition={customTransition}
    customDot={customDot}
    afterChange={afterChange}
  >
    {children}
  </Carousel>
);

export default MultiCarousel;
